/**
 * long to short query parameter names.
 */
export const KEY_MAP: Record<string, string> = {
  module: 'm',
  routeName: 'rN',
  categoryName: 'cN',
} as const

export const query = (
  paramsObj: Record<string, unknown> | null | undefined,
  delimetr: boolean = true
): string => {
  if (!paramsObj || Object.keys(paramsObj).length === 0) return ''

  const query = new URLSearchParams()

  for (const [key, value] of Object.entries(paramsObj)) {
    if (value == null) continue

    if (Array.isArray(value)) {
      for (const v of value) {
        if (v == null) continue
        query.append(key, String(v))
      }
      continue
    }

    query.set(key, String(value))
  }

  return delimetr ? `?${query}` : query.toString()
}

export const addQuery = (
  url: string | undefined | null,
  paramsObj: Record<string, unknown> | null | undefined
): string => {
  if (!paramsObj || Object.keys(paramsObj).length === 0) return url ?? ''

  const hashIndex = url?.indexOf('#') ?? -1
  const hash = hashIndex >= 0 ? (url?.slice(hashIndex) ?? '') : ''
  const urlWithoutHash =
    hashIndex >= 0 ? (url?.slice(0, hashIndex) ?? '') : (url ?? '')

  const qIndex = urlWithoutHash.indexOf('?')
  const base = qIndex === -1 ? urlWithoutHash : urlWithoutHash.slice(0, qIndex)
  const originalQueries =
    qIndex === -1 || !qIndex ? '' : urlWithoutHash.slice(qIndex + 1)

  const originalParams = Object.fromEntries(
    new URLSearchParams(originalQueries)
  )

  // remove null / undefined / ''
  const filteredParams = Object.fromEntries(
    Object.entries(paramsObj).filter(([_, v]) => v != null && v !== '')
  )

  // removed duplicates
  const queryStr = query({ ...originalParams, ...filteredParams }, false)

  if (!urlWithoutHash) {
    if (queryStr) return `?${queryStr}${hash}`
    return ''
  }

  return `${base}?${queryStr}${hash}`
}
